'use strict';
import React, { Component } from 'react';
import { GenericModal, GenericErrorScreen, MessagePopup } from 'com-gyf-webcore-userinterfacecomponents';
import { createForm } from 'rc-form';
import { Redirect } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager.js';


import { AdicionalesMock, NuevoAdicional, ATLAS_VIGENCIA_TARJETA_TEMPORAL, CuartaLinea, CodigosDistribucion } from './ClienteAdicionalMock.js'
import ModalDefecto from "../../../Common/Components/ModalDefecto.jsx"
import Adicionales from '../../NuevaSolicitudCuenta/components/Adicionales.jsx'
import Footer from './Footer.jsx'
import Breadcrumb from '../../NuevaSolicitudAdministradora/components/MarcaBreadcrumb.jsx';
import ClienteTitle from '../../NuevaSolicitudAdministradora/components/ClienteTitle.jsx';
import NuevaSolicitudDatos from '../../NuevaSolicitudDatos/components/Container.jsx';
import DatosIncorrectos from '../../NuevaSolicitudDatos/components/DatosIncorrectos.jsx';
import Table from './Tabla/Table.jsx';
import TituloIntegrante from './TituloIntegrante.jsx';
import Denominacion from './Denominacion.jsx';
import TipoVigencia from './TipoVigencia.jsx';
import CostoEmision from './CostoEmision.jsx';
import DenominacionCuartaLinea from './DenominacionCuartaLinea.jsx';
import Distribucion from './Distribucion.jsx';
import HabilitacionCajeros from './HabilitacionCajeros.jsx';
import CargoCajero from './CargoCajero.jsx';
import CentroCostos from './CentroCostos.jsx';
import Limites from './Limites.jsx';
import LimiteCompra from './LimiteCompra.jsx';
import ButtonsAdd from './ButtonsAdd.jsx';
import ModalCancelarTarjeta from './CancelarEdicionActualModal.jsx';
import EliminarAdicionalModal from './EliminarAdicionalModal.jsx';

class NuevoSolicitudAdicional extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumb: [],
            OpenModal: false,
            redirect: false,
            productoSeleccionado: false,
            redirectCancel: false,
            abrirModalDatos:false
        }
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleModalNo = this.toggleModalNo.bind(this);
        this.aceptModalCuentas = this.aceptModalCuentas.bind(this);
        this.redirectDatosCorrectos = this.redirectDatosCorrectos.bind(this);
        this.volverNSC = this.volverNSC.bind(this);        
        this.cancelarAdicional = this.cancelarAdicional.bind(this);        
        this.eliminarAdicional = this.eliminarAdicional.bind(this);        
        this.abrirModalDatos = this.abrirModalDatos.bind(this);        
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        const admin = this.props.tarjetas.administradora && this.props.tarjetas.administradora.Id ? this.props.tarjetas.administradora.Id : this.props.tarjetas.administradoraId;
        const tipoCliente = this.props.tarjetas.tipoEmpresa.EmpresaIndividuos;
        const tipoCuenta = this.props.tarjetas.tipoEmpresa.Descripcion;

        this.breadcrumbGenerator(admin,tipoCliente,tipoCuenta)
        this.props.getScreenData(id, this.props.currentScope);
    }

    toggleModal(modal) {
        
        if(modal == "SolicitudAltaDeCuenta"){
            if(this.props.tarjetas.clienteTarjeta){
                $('#SolicitudAltaDeCuenta').modal('toggle');
            }
        }else if(modal == "EliminarAdicional"){
            $('#EliminarAdicional').modal('toggle');
        }else{
            
            $('#CancelarEdicionActual').modal('toggle');
        }
    }

    toggleModalNo() {
        this.props.confirmarClienteTarjeta(false);
    }

    aceptModalCuentas() {
        this.setState({ redirectCancel: true });
        $('#datosIncorrectos').modal('toggle');
    }

    redirectDatosCorrectos() {
        this.setState({ redirect: true });
    }

    redirect = (closePopUp) => {
        closePopUp();
        this.setState({ redirectCancel: true });
    }

    cancelarAdicional(solicitud){
        this.props.cancelarAdicional(solicitud);
        this.props.confirmarClienteTarjeta(false);
    }

    eliminarAdicional(id){
        this.setState({idAdicional:id});
        $('#EliminarAdicional').modal('toggle');
    }

    volverNSC() {
        this.props.volverASolicitud(true);
        this.setState({ volverNSC: true })
    }
    componentWillUnmount(){
        this.props.cleanStore();
    }
    abrirModalDatos(){
        this.setState({abrirModalDatos:true})
    }
    render() {
        const { NSC,data, tarjetas, onBlurTextBox, routeToVistaCliente, routeToNuevaSolicitudCuenta, selectCheckBox, selectCombo, changeInput, showPopUpCancelAdic, closePopUp, validateCuenta, guardarBorrador, stopRedirectVistaCliente, edicionClienteAdicional/*, mostrarDatosTitular*/, borrarClienteAdicional } = this.props;
        const { redirectVistaCliente } = data;
        const { tipoEmpresa, solicitudCuenta, clienteResultadoBusqueda,clienteTarjeta } = tarjetas;

        const Cliente = clienteTarjeta ? clienteTarjeta : {}

        Cliente.esPersonaFisica = Cliente.DatosClientes && Cliente.DatosClientes.TipoPersona == "F";

        let spinner = null;
        let modalCancel = null;
        let componentes = null;
        let parametroGeneral = {};
        let producto = {};
        let muestraLimitesVisa = true;
        let numeroIntegrante = 0;
        let comienzaEn = 0;
        if(tarjetas && tarjetas.tipoEmpresa.EmpresaIndividuos == "E") comienzaEn = 1;
        numeroIntegrante+=comienzaEn
        numeroIntegrante+=tarjetas.solicitudCuenta.cuentasAdicionales.length  

        //cuando se espera la respuesta del WS antes de abrir el modal de datos **TODO agregar a todos los casos**
        if(this.state.abrirModalDatos && tarjetas.clienteTarjeta != null && !tarjetas.loadingCliente){
            this.toggleModal("SolicitudAltaDeCuenta");
            this.setState({abrirModalDatos:false});
        }

        if(solicitudCuenta){
            //SE MUESTRA SECCIÓN "LÍMITES" PARA VISA SÓLO SI LA MODALIDAD DE DISTRIBUCIÓN DE LÍMITES NO ES "SIN LÍMITE"
            parametroGeneral = solicitudCuenta.GET_ATLAS_PARAMETRO_GENERAL;
            producto = tarjetas.administradora.Id == 1 ? solicitudCuenta.GET_PRODUCTO_VISA_PRODUCTO_ID : solicitudCuenta.GET_PRODUCTO_CABAL_PRODUCTO_ID;
            tarjetas.administradora.Id == 1 && solicitudCuenta.GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID.map(modalidad=>{
                if((modalidad.CODIGO == "SINLIMITE1" || modalidad.CODIGO == "SINLIMITE") && modalidad.Id == solicitudCuenta.modeloDistribucionId) muestraLimitesVisa = false
            })
            
        }
                

        if ((NSC && NSC.isFetching == true) || data.guardandoAdicionalesCuentaOperativa)
            spinner = <div className="loading" />

        if (data.routeToNuevaSolicitudCuenta == true)
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitudAdicional", "ROUTE_TO_DATOS_CUENTA")} push />

        modalCancel = <ModalDefecto
            id={"CancelAdicional"}
            titulo={"Cancelar Solicitud"}
            mensaje={"¿Desea cancelar la solicitud y volver a la pantalla principal?"}
            routeDesde={"NuevaSolicitudAdicional"}
            routeHasta={"ROUTE_TO_VISTA_CLIENTE"}
        />

        switch (tarjetas.administradora.Abreviatura) {
            case "C":
                componentes = <div>
                    {Cliente.esPersonaFisica && parametroGeneral.SINODENOMINACIONCUARTALINEA && (producto.TipoGrabadoCuartaLinea || tarjetas.esCuentaExistente) &&
                    <DenominacionCuartaLinea data={data} tarjetas={tarjetas} solicitudCuenta={tarjetas.solicitudCuenta} changeInput={changeInput} onBlurTextBox={onBlurTextBox} />}
                    <LimiteCompra data={data} tarjetas={tarjetas} changeInput={changeInput} />
                    </div>
                break;
            case "V":
                componentes = <div>
                    <Denominacion tarjetas={tarjetas} data={data} changeInput={changeInput} />
                    <TipoVigencia data={data} tarjetas={tarjetas} selectCheckBox={selectCheckBox} tarjetasTemporales={ATLAS_VIGENCIA_TARJETA_TEMPORAL} selectCombo={selectCombo} />
                    {(tarjetas.tipoEmpresa && tarjetas.tipoEmpresa.EmpresaIndividuos =="I") &&
                        <CostoEmision  data={data} tarjetas={tarjetas} solicitudCuenta={tarjetas.solicitudCuenta} changeInput={changeInput} />
                    }
                    {Cliente.esPersonaFisica && parametroGeneral.SINODENOMINACIONCUARTALINEA && (producto.TipoGrabadoCuartaLinea || tarjetas.esCuentaExistente) &&
                        <DenominacionCuartaLinea data={data} tarjetas={tarjetas} solicitudCuenta={tarjetas.solicitudCuenta} changeInput={changeInput} onBlurTextBox={onBlurTextBox} />
                    }
                    {Cliente.esPersonaFisica && (solicitudCuenta.GET_PRODUCTO_VISA_PRODUCTO_ID.UtilizaCodigoDistribucion || tarjetas.esCuentaExistente) &&
                        <Distribucion data={data} tarjetas={tarjetas} selectCombo={selectCombo} />
                    }
                    {Cliente.esPersonaFisica &&
                        <HabilitacionCajeros data={data} tarjetas={tarjetas} solicitudCuenta={tarjetas.solicitudCuenta} selectCombo={selectCombo} />
                    }

                    {solicitudCuenta.GET_ATLAS_PARAMETRO_GENERAL.SINOREDBANELCO &&
                        <CargoCajero tarjetas={tarjetas} selectCheckBox={selectCheckBox} data={data} cargo={tarjetas.solicitudCuenta && tarjetas.solicitudCuenta.GET_PRODUCTO_VISA_PRODUCTO_ID.UsoATM} />
                    }
                    {tipoEmpresa.EmpresaIndividuos == "E" &&
                        <CentroCostos data={data} changeInput={changeInput} />
                    }
                    {muestraLimitesVisa && 
                    <Limites administradora={tarjetas.administradora.Abreviatura} data={data} tarjetas={tarjetas} solicitudCuenta={solicitudCuenta} selectCheckBox={selectCheckBox} changeInput={changeInput} />
                    }
                </div>
                break;
        }
        
        return (

            <div>
                <ModalCancelarTarjeta abrirModalDatos={this.abrirModalDatos}  buscarPorCuit={this.props.buscarPorCuit} buscarCliente={data.buscarCliente} integrante={numeroIntegrante} tarjetas={tarjetas} toggleModal={this.toggleModal} />
                <EliminarAdicionalModal idAdicional={this.state.idAdicional} borrarClienteAdicional={borrarClienteAdicional} toggleModal={this.toggleModal} />
                {modalCancel}
                {spinner}
                <ModalDefecto
                    id={"solicitudGuardada"}
                    titulo={"Solicitud Guardada"}
                    mensaje={"Se registró la solicitud correctamente."}
                    routeDesde={"NuevaSolicitudAdicional"}
                    routeHasta={"ROUTE_TO_VISTA_CLIENTE"}
                    soloAceptar={true}
                />
                <MessagePopup isHidden={data.messageHidden}
                    message={data.message}
                    classMessage={data.messageClass} />
                <div className="row">
                    <div className="col-md-12">
                        <ClienteTitle className="breadcrumb"
                            cliente={this.props.tarjetas.clienteResultadoBusqueda}
                            empresas={null}
                            novedadesempresas={null}
                            esModificacion={tarjetas.esModificacion} />
                    </div>
                </div>

                <div className="row">
                    {!tarjetas.esCuentaExistente ? 
                    <div className="col-md-12">
                        <Breadcrumb className="breadcrumb" currentScreen={null} menu={this.state.breadcrumb} product={null} module={null} />
                    </div>:
                    <div className="col-md-12">
                        <h1>Nueva Solicitud de Adicionales/Extensiones de Cuenta</h1>
                    </div>
                    }
                </div>
                <div className="container-fluid container-fluid-bordered">

                    {!tarjetas.denominacionCuentaExistente ? <h1>Integrantes de la Cuenta</h1> : <h1>{"Integrantes de la Cuenta " + tarjetas.denominacionCuentaExistente }</h1> }
                    <Table confirmarClienteTarjeta={this.props.confirmarClienteTarjeta} data={data} tarjetas={tarjetas} edicionClienteAdicional={edicionClienteAdicional} borrarClienteAdicional={this.eliminarAdicional} />
                    <TituloIntegrante data={data} idAdicional={data.idAdicional} tarjetas={tarjetas} cliente={tarjetas.clienteTarjeta} />
                    { tarjetas.clienteTarjeta && componentes}
                    <DatosIncorrectos onclick={this.aceptmodalcuentas}/>
                    {tarjetas.clienteTarjeta && 
                        <ButtonsAdd
                            data={data}    
                            solicitudCuenta={solicitudCuenta}
                            administradora={tarjetas.administradora.Abreviatura}
                            validate={validateCuenta}
                            changeInput={changeInput}
                            tarjetas={tarjetas}
                            cancelarAdicional={this.cancelarAdicional}
                            confirmarClienteTarjeta={this.props.confirmarClienteTarjeta}
                        />
                    }
                    <div className="datos-cuenta">
                        <Adicionales  confirmarClienteTarjeta={this.props.confirmarClienteTarjeta} buscarPorCuit={this.props.buscarPorCuit}  toggleModal={this.toggleModal} pantallaActual="NuevaSolicitudAdicional" buscarCliente={this.props.data.buscarCliente} toggleModal={this.toggleModal} cargarClienteTarjeta={this.props.cargarClienteTarjeta} tarjetas={tarjetas} data={data} onBlurTextBox={onBlurTextBox} />
                    </div>
                    { <NuevaSolicitudDatos
                        administradora="VISA"
                        cliente={tarjetas.clienteTarjeta}
                        toggleModal={this.toggleModal}
                        aceptModalCuentas={this.aceptModalCuentas}
                        esAdicional={true}
                        redirect={this.redirectDatosCorrectos}
                        callback={this.toggleModalNo}
                        loadingCliente={tarjetas.loadingCliente}/>
                    }
                </div>
                <Footer data={data}
                    screen={"NuevaSolicitudAdicional"}
                    routeToBack={"ROUTE_TO_CUENTA"}
                    routeToNext={""}
                    validate={validateCuenta}
                    showPopUpCancelAdic={showPopUpCancelAdic}
                    routeToVistaCliente={routeToVistaCliente}
                    routeToNuevaSolicitudCuenta={routeToNuevaSolicitudCuenta}
                    closePopUp={closePopUp}
                    guardarBorrador={guardarBorrador}
                    nuevaSolicitudCuenta={solicitudCuenta}
                    volverASolicitud={this.props.volverASolicitud}
                    esCuentaExistente={tarjetas.esCuentaExistente}
                    validarNSC={this.props.validarNSC}
                    tarjetas={tarjetas}
                    NSC={this.props.NSC}
                    data={data}
                    guardarAdicionalCuentaExistente={this.props.guardarAdicionalCuentaExistente}
                />
                
            </div>);
    }

    breadcrumbGenerator(idAdm, letraFiltro,tipoCuenta) {
        let nuevaSolicitudMap = [];

        nuevaSolicitudMap.push({ descripcion: this.props.tarjetas.administradora.Descripcion, ruta: "", activo: false, normal: true, anterior: true });
        nuevaSolicitudMap.push({ descripcion: tipoCuenta, ruta: "", activo: false, normal: true, anterior: true });
        letraFiltro == "E" && nuevaSolicitudMap.push({ funcion: this.volverNSC, descripcion: "Empresa", ruta: "", activo: false, normal: true, anterior: true });
        nuevaSolicitudMap.push({ funcion: this.volverNSC, descripcion: "Datos de la Cuenta", ruta: "", activo: false, normal: true, anterior: true });
        nuevaSolicitudMap.push({ descripcion: letraFiltro == "I" ? "Adicionales" : "Extensiones", ruta: "", activo: true, normal: false, anterior: false });

        this.setState({ breadcrumb: nuevaSolicitudMap })

    }
}

export default createForm()(NuevoSolicitudAdicional);
